.rating {
  position: absolute;
  top: var(--mantine-spacing-xs);
  right: 12px;
  cursor: pointer;
  background: transparent;
  transition: transform 150ms ease;
}

.rating:hover {
  transform: scale(1.2);
  background: transparent;
}

.card {
  border: 1px solid #002d72;
  height: 100%;
}

.cardSection {
  border-bottom: 4px solid #002d72;
}
